module.exports = __webpack_public_path__ + "img/factory.2023b300.png";